module.exports = __webpack_public_path__ + "img/onclick.1a4a141f.png";